import DeviceSensor from './DeviceSensor';
import ExponentMagnetometerUncalibrated from './ExponentMagnetometerUncalibrated';
/**
 * @platform android
 * @platform ios
 */
export class MagnetometerUncalibratedSensor extends DeviceSensor {
}
export default new MagnetometerUncalibratedSensor(ExponentMagnetometerUncalibrated, 'magnetometerUncalibratedDidUpdate');
//# sourceMappingURL=MagnetometerUncalibrated.js.map